angular.module('main').directive('btnCopyToXero', btnCopyToXero);
btnCopyToXero.$inject = [
	'integrationsDataService',
	'messageService',
	'invoiceService',
	'$route',
	'$timeout'
];

function btnCopyToXero(
	integrationsDataService,
	messageService,
	invoiceService,
	$route,
	$timeout
) {
	return {
		restrict: 'E',
		scope: {
			invoiceData: '<',
			invoiceId: '<',
			invoiceDisplayId: '<',
			successGetInvoiceInformation: '&'
		},
		template: `<button ng-disabled="isBtnDisabled" type="button" class="btn btn-default" ng-click="copyToXero(invoiceId)">
                            <i class="fi fa fa-files-o"></i>Copy to Xero
                       </button>`,
		replace: true,
		transclude: true,
		link(scope) {
			scope.isBtnDisabled = false;

			scope.copyToXero = id => {
				scope.isBtnDisabled = true;

				if (!isInvoiceValid(scope.invoiceData)) {
					integrationsDataService
						.copyInvoiceToXero(id)
						.finally(() => (scope.isBtnDisabled = false))
						.subscribe(
							data => successCopyToXero(data),
							error => errorCopyToXero(error)
						);
				} else {
					scope.isBtnDisabled = false;
				}
			};

			function successCopyToXero(data) {
				const result = { data };
				scope.successGetInvoiceInformation({ result });
				messageService.showToaster('s_1', 'xero');
				$timeout($route.reload(), 300);
			}

			function errorCopyToXero({ data, status }) {
				const errorMessage = data ? data.errorMessage : null;
				let errorCode, errorPlace, value;
				if (errorMessage && status >= 400 && status < 500) {
					switch (errorMessage) {
						case "Paid or partially paid invoice can't be updated on Xero":
							errorCode = 'e_5';
							errorPlace = 'xero';
							break;
						case 'Invoice with such invoice ID (Invoice Number) exists on Xero':
							errorCode = 'e_6';
							errorPlace = 'xero';
							value = scope.invoiceDisplayId;
							break;
						case 'Product/Package tax type is not compatible with Xero':
							errorCode = 'e_4';
							errorPlace = 'xero';
							break;
						case 'Fixed discount is not compatible with Xero':
							errorCode = 'e_1';
							errorPlace = 'xero';
							break;
						case 'Invoice is Voided or Deleted on Xero':
							errorCode = 'e_3';
							errorPlace = 'xero';
							break;
						case 'Invoice with written off payments is not compatible with Xero':
							errorCode = 'e_7';
							errorPlace = 'xero';
							break;
						case 'Xero access token expired, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case 'Bummer! Xero access token revoked, reconnect Xero please':
							errorCode = 'e_14';
							errorPlace = 'xero';
							break;
						case "Bummer! You don't have an active Xero subscription.":
							errorCode = 'e_15';
							errorPlace = 'xero';
							break;
						default:
							errorCode = 'e_2';
							errorPlace = 'general';
							value = errorMessage;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}

			function isInvoiceValid(invoice) {
				const dataToValidate = {
					amount: invoice.invoiceSummary.amount,
					packages: invoice.invoiceSummary.productPackageSummaries,
					payments: invoice.payments,
					discount: invoice.discount,
					discountType: invoice.discountType.value,
					xeroStatus: invoice.xeroStatus,
					qbStatus: invoice.qbStatus,
					totalDue: invoice.invoiceSummary.totalDue,
					pageName: 'invoicePage'
				};

				return dataToValidate.packages.some(packages =>
					invoiceService.isInvalidProduct(
						packages.productPackageDTO,
						dataToValidate.pageName
					)
				);
			}
		}
	};
}



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnCopyToXero.js